var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowHeadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_4444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9908 5.91891L7.83697 10.765C7.94905 10.8772 8.09868 10.939 8.25822 10.939C8.41776 10.939 8.56738 10.8772 8.67947 10.765L9.03636 10.4082C9.26858 10.1757 9.26858 9.79783 9.03636 9.56569L4.96691 5.49625L9.04087 1.42229C9.15296 1.31011 9.21484 1.16057 9.21484 1.00112C9.21484 0.841494 9.15296 0.691957 9.04087 0.579694L8.68399 0.222984C8.57181 0.110809 8.42227 0.0490121 8.26273 0.0490121C8.10319 0.0490121 7.95357 0.110809 7.84148 0.222984L2.9908 5.07349C2.87845 5.18602 2.81674 5.33626 2.81709 5.49598C2.81674 5.65632 2.87845 5.80647 2.9908 5.91891Z",
    fill: "#222222",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_4444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.89,
    height: 10.89,
    fill: "white",
    transform: "translate(11.4609 10.9385) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowHeadIcon);
export default __webpack_public_path__ + "static/media/leftArrowHeadIcon.dca9da9e4d9b3b79d167fa2b450ef597.svg";
export { ForwardRef as ReactComponent };